<template>
  <div id="settings-email">
    <div class="container">

      <div class="header-actions">
        <div></div>
        <button class="btn btn-primary" @click="saveConfig">{{ $t("save") }}</button>
      </div>

      <Tabs>
        <TabSection :title="$t('settings.sale_email_config')">
          <div class="group">
            <LocalizedInput textarea :title="$t('settings.sale_email_top_message')"
              :translate="config.saleEmailMessage.top" open ref="localizedInput" />
          </div>
          <div class="group">
            <LocalizedInput textarea :title="$t('settings.sale_email_end_message')"
              :translate="config.saleEmailMessage.bottom" open />
          </div>
          <div class="preview-config">
            <button class="btn btn-primary" @click="previewSaleEmail">{{ $t("preview") }}</button>
            <select v-model="previewLanguage">
              <option :value="null">{{ $t('language') + ' ...' }}</option>
              <option :value="language" v-for="language of languages" :key="`loc_${language}`">
                {{ $t(`translation.${language}`) }}</option>
            </select>
            <AjaxSelect ref="ajaxSelect" v-model="previewSale" :api="`/api/companies/${companyId}/sales`"
              :query="{ augment: 'short', perPage: 5, 'order-id': 'desc' }" :map-fn="(s) => `#${s.id}`"
              :allow-empty-search="true" :placeholder="$t('settings.search_sale_to_preview')" />
          </div>
        </TabSection>

        <TabSection :title="$t('preview')" v-if="previewHtml">
          <iframe :srcdoc="previewHtml" width="100%" height="500" frameborder="0" />
        </TabSection>
      </Tabs>

    </div>
  </div>
</template>

<script>
  import AjaxSelect from "@/components/tools/AjaxSelect";
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import { Core } from "@/core/Core";
  import { mapActions } from "vuex";

  export default {
    name: "SettingsEmail",

    components: { LocalizedInput, AjaxSelect },

    data() {
      return {
        previewLanguage: null,
        previewSale: { id: null },
        previewHtml: null,

        localizedInputRef: null,
        config: {
          saleEmailMessage: {
            top: {},
            bottom: {}
          }
        }
      }
    },

    computed: {
      branchId() {
        return this.$route.query.branch;
      },
      companyId() {
        return this.$route.query.company;
      },
      languages() {
        return this.localizedInputRef ? this.localizedInputRef.languages : []
      },
      sanitizedConfig() {
        let clonedConfig = JSON.parse(JSON.stringify(this.config));
        if (this.isEmptyTranslation(clonedConfig.saleEmailMessage.top)) {
          delete clonedConfig.saleEmailMessage.top
        }
        if (this.isEmptyTranslation(clonedConfig.saleEmailMessage.bottom)) {
          delete clonedConfig.saleEmailMessage.bottom
        }
        if (Object.keys(clonedConfig.saleEmailMessage).length === 0) {
          clonedConfig.saleEmailMessage = null;
        }
        return clonedConfig;
      }
    },

    watch: {
      companyId: {
        immediate: true,
        async handler() {
          if (!this.companyId) { return; }

          showSpinner();
          let company = await this.getCompany({
            branchId: this.branchId,
            companyId: this.companyId
          });
          hideSpinner();

          let saleEmailMessage = company.saleEmailMessage || {};
          this.config.saleEmailMessage.top = saleEmailMessage.top || {};
          this.config.saleEmailMessage.bottom = saleEmailMessage.bottom || {};
        }
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.emails_configuration";
      this.$store.state.pageIcon = "";

      this.localizedInputRef = this.$refs.localizedInput;
    },

    methods: {
      ...mapActions(['getCompany', 'saveCompany']),

      isEmptyTranslation(obj) {
        return typeof obj !== 'object'
          || Object.values(obj).filter(v => typeof v === 'string' && !!v.trim()).length === 0
      },

      async previewSaleEmail() {
        let data = {
          company: Object.assign({ id: this.companyId }, this.sanitizedConfig),
          language: this.previewLanguage,
          sale: {
            id: this.previewSale.id
          }
        }
        showSpinner();
        try {
          this.previewHtml = await Core.request('POST', `/api/communication_test/sale_email/preview`, data, { htmlResponse: true });
        } catch (e) {
          toast(this.$t("error.no_server"), 'error');
        }
        hideSpinner();
      },
      async saveConfig() {
        showSpinner();
        try {
          await this.saveCompany({
            branchId: this.branchId,
            companyId: this.companyId,
            data: this.sanitizedConfig
          });
        } catch (e) {
          toast(this.$t("error.no_server"), 'error');
        }
        hideSpinner();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header-actions {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .preview-config {
    display: flex;
    justify-content: center;
    margin-top: 50px;

    > :not(:last-child) {
      margin-right: 10px;
    }
  }
</style>